import { DocumentMinusIcon } from "@heroicons/react/24/solid";
const DeactivateButton = ({
  children,
  buttonValue = children ? "" : "Deactivate",
  onClickFunction,
  className,
  type = "button",
  disabled = false,
}) => {
  return (
    <button
      type={type}
      value={buttonValue}
      disabled={disabled}
      onClick={onClickFunction}
      className={
        (disabled
          ? "cursor-not-allowed border text-quinary opacity-50  border-quinary "
          : " gap-1 text-quinary border-quinary opacity-100") +
        `h-5 lg:h-6 lg:w-28 lg:px-1 w-24 text-quinary border-quinary opacity-100 hover:scale-90
         transition duration-500 shadow-md border-quinary bg-tranparent hover:bg-quinary 
        text-quinary group relative flex justify-center py-1 px-3 border  text-xs font-medium rounded-full 
        hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quinary focus:ring-opacity-70 ${className}`
      }
    >
      {buttonValue}
      {children}
    </button>
  );
};
export default DeactivateButton;
